import { useQuery } from "@tanstack/react-query";
import { db } from "@/lib/db";
import type { NavBadge } from "@/navigation/registry";

/** Real queue counts for sidebar badges. Nothing here is estimated. */
export const useNavBadges = (enabled: boolean): Partial<Record<NavBadge, number>> => {
  const { data } = useQuery({
    queryKey: ["nav-badges"],
    enabled,
    staleTime: 60_000,
    refetchInterval: 120_000,
    queryFn: async () => {
      const { count, error } = await db
        .from("app_translations")
        .select("id", { count: "exact", head: true })
        .in("status", ["needs_review", "proposed"]);
      if (error) return {};
      return { "mizo-strings": count ?? 0 } as Partial<Record<NavBadge, number>>;
    },
  });
  return data ?? {};
};
